<template>
    <div class="">
        <div class="w-full shadow rounded w-full">
            <div class="bg-gray-200 flex">
                <div class="px-4 py-2 text-gray-600 uppercase text-sm text-left w-35%">Beschreibung</div>
                <div class="px-4 py-2 text-gray-600 uppercase text-sm text-left w-5%">Gebühr</div>
                <div class="px-4 py-2 text-gray-600 uppercase text-sm text-right w-15%">Gegenstandswert</div>
                <div class="px-4 py-2 text-gray-600 uppercase text-sm text-right w-10%">Netto</div>
                <div class="px-4 py-2 text-gray-600 uppercase text-sm text-right w-5%">Ust</div>
                <div class="px-4 py-2 text-gray-600 uppercase text-sm text-right w-10%">Brutto</div>
                <div class="px-4 py-2 text-gray-600 uppercase text-sm text-right w-20%"></div>
            </div>
            <div v-for="(item, i) in items" class="w-full border-b border-dotted border-gray-300 hover:bg-gray-100 py-3">
                <invoice-rvg-item-form
                        :initial-item="item"
                        :new-record="false"
                        :default-jurisdictional-amount="dossier.jurisdictional_amount"
                        v-if="item.type=='InvoiceRvgItem'"
                        :key="item.id"
                />
                <invoice-free-item-form
                        v-if="item.type=='InvoiceFreeItem'"
                        :initial-item="item"
                        @item-removed="removeItem(item)"
                        :key="item.id"
                />
            </div>
            <div ref="itemContainer"></div>
            <div class="px-4 py-3">
                <button @click="addNewFreeItem()" class="btn btn-small btn-secondary">
                    <i class="far fa-plus-square"></i> Weiteren Posten hinzufügen
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import InvoiceFreeItemForm from './free_item_form.vue'

    export default {
        components: { InvoiceFreeItemForm },
        props: [
            'invoiceId',
            'initialItems',
            'initialDossier',
            'section',
        ],
        data() {
            return {
                items: JSON.parse(this.initialItems),
                dossier: JSON.parse(this.initialDossier),
            }
        },
        methods: {
            newFreeItem: function() {
                return {type: 'InvoiceFreeItem', section: this.section, invoice_id: this.invoiceId, description: '', hidden: true, new_record: true };
            },
            removeItem: function(item) {
                console.log('DELETE INDEX' + this.items.indexOf(item));
                this.items.splice(this.items.indexOf(item), 1);
            },
            addNewFreeItem: function() {
                // var InvoiceFreeItemFormClass = Vue.extend(InvoiceFreeItemForm)
                // var instance = new InvoiceFreeItemFormClass({
                //     propsData: {
                //         initialItem: this.newFreeItem(),
                //         newRecord: true,
                //     }
                // })
                // // instance.$slots.default = [ '42' ]
                // instance.$mount() // pass nothing
                // this.$refs.itemContainer.appendChild(instance.$el)
                this.items.push(this.newFreeItem());
                this.$forceUpdate()
            }
        },

        mounted: function () {
        }
    }
</script>
